import React from 'react';
import Importance from './Importance';
import PlanAdditional from './PlanAdditional';
import PlanStudy from './PlanStudy';
import {Link} from 'react-router-dom';

const LessonPlanPage2 = () => {
  return (
    <div>
      <div className="font-5 fw-bold text-center" style={{height: 50}}>
        Глаголы
      </div>
      <div className="col-lg-3 mx-auto text-center">
        <div className="border bg-white px-2 py-3 mb-3 position-relative">
          <Importance stars={5} />
          <PlanStudy levels={[12]} />
          <Link to="/my-lessons/12/grammar">Неопределенная форма</Link>
        </div>
      </div>
      <div className="row gx-lg-4 gy-4 text-center">
        <div className="col-lg-3">
          <div className="border bg-white px-2 py-3 mb-3 position-relative">
            <Importance stars={5} />
            <PlanStudy levels={[13, 14, 15]} />
            <div>Повелительное наклонение</div>
            <PlanAdditional
              levels={
                <div className="mt-3 text-start font-2">
                  <div className="row align-items-center mt-2">
                    <span className="col">
                      <Link to="/my-lessons/13/grammar">Повелительное наклонение</Link>
                    </span>
                    <span className="col-auto">
                      <PlanStudy levels={[13]} notAbsolute />
                    </span>
                  </div>
                  <div className="row align-items-center mt-2">
                    <span className="col">
                      <Link to="/my-lessons/14/grammar">Отрицательная форма</Link>
                    </span>
                    <span className="col-auto">
                      <PlanStudy levels={[14]} notAbsolute />
                    </span>
                  </div>
                  <div className="row align-items-center mt-2">
                    <span className="col">
                      <Link to="/my-lessons/15/grammar">Множественное число</Link>
                    </span>
                    <span className="col-auto">
                      <PlanStudy levels={[15]} notAbsolute />
                    </span>
                  </div>
                </div>
              }
            />
          </div>
          {/*<div className="border bg-white px-2 py-3 mb-3 position-relative">*/}
          {/*  <Importance stars={5} />*/}
          {/*  <div className="text-center">*/}
          {/*    Повелительное наклонение.*/}
          {/*    <br />*/}
          {/*    Уважительная форма*/}
          {/*  </div>*/}
          {/*  <PlanStudy levels={[13, 14, 15]} />*/}
          {/*  <PlanAdditional*/}
          {/*    levels={*/}
          {/*      <div className="mt-3 text-start font-2">*/}
          {/*        <div className="mt-2">Повелительное наклонение. Уважительная форма</div>*/}
          {/*        <div className="mt-2">Отрицательная форма</div>*/}
          {/*        <div className="mt-2">Множественное число</div>*/}
          {/*      </div>*/}
          {/*    }*/}
          {/*  />*/}
          {/*</div>*/}
          <div className="border bg-white px-2 py-3 mb-3 position-relative">
            <Importance stars={4} />
            <PlanStudy levels={[16]} />
            <Link to="/my-lessons/16/grammar">Повелительное наклонение. Просительная форма</Link>
          </div>
          <div className="border bg-white px-2 py-3 mb-3 position-relative">
            <Importance stars={1} />
            <PlanStudy levels={[71]} />
            <Link to="/my-lessons/71/grammar">Повелительное наклонение. Настоятельная форма</Link>
          </div>
        </div>
        <div className="col-lg-3">
          <div className="border bg-white px-2 py-3 mb-3 position-relative">
            <Importance stars={4} />
            <div>
              Повелительное наклонение.
              <br />1 лицо
            </div>
            <PlanStudy levels={[43, 44]} />
            <PlanAdditional
              levels={
                <div className="mt-3 text-start font-2">
                  <div className="row align-items-center mt-2">
                    <span className="col">
                      <Link to="/my-lessons/43/grammar">Повелительное наклонение. 1 лицо</Link>
                    </span>
                    <span className="col-auto">
                      <PlanStudy levels={[43]} notAbsolute />
                    </span>
                  </div>
                  <div className="row align-items-center mt-2">
                    <span className="col">
                      <Link to="/my-lessons/44/grammar">Отрицательная форма</Link>
                    </span>
                    <span className="col-auto">
                      <PlanStudy levels={[44]} notAbsolute />
                    </span>
                  </div>
                </div>
              }
            />
          </div>
          <div className="border bg-white px-2 py-3 mb-5 position-relative">
            <Importance stars={4} />
            <PlanStudy levels={[45]} />
            <Link to="/my-lessons/45/grammar">Повелительное наклонение. 3 лицо</Link>
          </div>
          <div className="border bg-white px-2 py-3 mb-3 position-relative">
            <Importance stars={3} />
            <PlanStudy levels={[49]} />
            <Link to="/my-lessons/49/grammar">Деепричастие</Link>
            <br />
            <span className="fst-italic">-ып, -iп, -п</span>
          </div>
          <div className="border bg-white px-2 py-3 mb-3 position-relative">
            <Importance stars={5} />
            <PlanStudy levels={[47]} />
            <Link to="/my-lessons/47/grammar">Причастие</Link>
            <br />
            <span className="fst-italic">-қан, -кен, -ған, -ген</span>
          </div>
          <div className="border bg-white px-2 py-3 mb-3 position-relative">
            <Importance stars={5} />
            <PlanStudy levels={[48]} />
            <Link to="/my-lessons/48/grammar">Причастие</Link>
            <br />
            <span className="fst-italic">-атын, -етін, -йтын, -йтін</span>
          </div>
        </div>
        <div className="col-lg-3">
          <div className="border bg-white px-2 py-3 mb-3 position-relative">
            <Importance stars={5} />
            <PlanStudy levels={[41, 42]} />
            <div>Условное наклонение</div>
            <PlanAdditional
              levels={
                <div className="mt-3 text-start font-2">
                  <div className="row align-items-center mt-2">
                    <span className="col">
                      <Link to="/my-lessons/41/grammar">Условное наклонение</Link>
                    </span>
                    <span className="col-auto">
                      <PlanStudy levels={[41]} notAbsolute />
                    </span>
                  </div>
                  <div className="row align-items-center mt-2">
                    <span className="col">
                      <Link to="/my-lessons/42/grammar">Отрицательная форма</Link>
                    </span>
                    <span className="col-auto">
                      <PlanStudy levels={[42]} notAbsolute />
                    </span>
                  </div>
                </div>
              }
            />
          </div>
          <div className="border bg-white px-2 py-3 mb-5 position-relative">
            <Importance stars={5} />
            <PlanStudy levels={[40]} />
            <Link to="/my-lessons/40/grammar">Желательное наклонение</Link>
          </div>
          <div className="border bg-white px-2 py-3 mb-3 position-relative">
            <Importance stars={5} />
            <PlanStudy levels={[38]} />
            <Link to="/my-lessons/38/grammar">Модальный глагол</Link>
            <br />
            <span className="fst-italic">Алу</span>
          </div>
          <div className="border bg-white px-2 py-3 mb-3 position-relative">
            <Importance stars={5} />
            <PlanStudy levels={[39]} />
            <Link to="/my-lessons/39/grammar">Модальный глагол</Link>
            <br />
            <span className="fst-italic">Болу</span>
          </div>
        </div>
        <div className="col-lg-3 text-center">
          <div className="border bg-white px-2 py-3 mb-3 position-relative">
            <Importance stars={5} />
            <PlanStudy levels={[67]} />
            <Link to="/my-lessons/67/grammar">Основной залог</Link>
          </div>
          <div className="border bg-white px-2 py-3 mb-3 position-relative">
            <Importance stars={4} />
            <PlanStudy levels={[67]} />
            <Link to="/my-lessons/67/grammar">Возвратный залог</Link>
          </div>
          <div className="border bg-white px-2 py-3 mb-3 position-relative">
            <Importance stars={4} />
            <PlanStudy levels={[68]} />
            <Link to="/my-lessons/68/grammar">Страдательный залог</Link>
          </div>
          <div className="border bg-white px-2 py-3 mb-3 position-relative">
            <Importance stars={3} />
            <PlanStudy levels={[69]} />
            <Link to="/my-lessons/69/grammar">Совместный залог</Link>
          </div>
          <div className="border bg-white px-2 py-3 mb-3 position-relative">
            <Importance stars={3} />
            <PlanStudy levels={[70]} />
            <Link to="/my-lessons/70/grammar">Понудительный залог</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LessonPlanPage2;
